export default "__VITE_ASSET__k3Iw9IRb__"